/*
 * @Author: Marte
 * @Date:   2017-11-7 
 * @Last Modified by:   liujinming
 * @Last Modified time: 2017-11-7
 */

'use strict';
/**
 *  Module
 *
 * Description
 */
angular.module('manageGroupsServiceModule', ['newCreateGroupModule'])
    .factory('manageGroupsService', ["$modal", "$q", function($modal, $q) {
        return{
            newCreateGroup: function(item){
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/command/manageGroups/manageGroupsService/newCreateGroup/newCreateGroup_tpl.html",
                    windowClass: 'newCreateGroup-window',
                    backdrop: false,
                    controller: "newCreateGroupCtrl",
                    resolve: {
                        item: function(){
                            return item;
                        }
                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            }
        };
    }]);